import React from "react";
import { SettingsSidebarNav } from "./settings/SettingsSidebarNav";
import { SidebarContent } from "./ui/sidebar";
import { ForgeWorkspaceSwitcher } from "./identity/ForgeWorkspaceSwitcher";
import { SidebarAccountFooter } from "./sidebar/SidebarAccountFooter";
import { SidebarUpdatePill } from "./sidebar/SidebarUpdatePill";
import { SearchAndCommandCenter } from "./sidebar/SearchAndCommandCenter";
import { ActiveThreadsSection } from "./sidebar/ActiveThreadsSection";
import { SidebarThreadUndoNotice } from "./sidebar/SidebarThreadUndoNotice";
import { useSidebarOrchestration } from "./sidebar/useSidebarOrchestration";

export default function Sidebar() {
  const state = useSidebarOrchestration();

  return (
    <>
      {state.isOnSettings ? (
        <SettingsSidebarNav pathname={state.pathname} />
      ) : (
        <>
          <SidebarContent className="gap-0">
            <SidebarThreadUndoNotice />
            <ActiveThreadsSection
              navigationChrome={
                <SearchAndCommandCenter
                  commandPaletteShortcutLabel={state.commandPaletteShortcutLabel}
                  newThreadRoute={state.newThreadRoute}
                />
              }
              sortedProjects={state.sortedProjects}
              isManualProjectSorting={state.isManualProjectSorting}
              projectSortOrder={state.projectSortOrder}
              threadSortOrder={state.threadSortOrder}
              updateSettings={state.updateSettings}
              shouldShowProjectPathEntry={state.shouldShowProjectPathEntry}
              handleStartAddProject={state.handleStartAddProject}
              isElectron={state.isElectron}
              expandedThreadListsByProject={state.expandedThreadListsByProject}
              activeRouteProjectKey={state.activeRouteProjectKey}
              routeThreadKey={state.routeThreadKey}
              newThreadShortcutLabel={state.newThreadShortcutLabel}
              handleNewThread={state.handleNewThread}
              archiveThread={state.archiveThread}
              unarchiveThread={state.unarchiveThread}
              settleThread={state.settleThread}
              unsettleThread={state.unsettleThread}
              deleteThread={state.deleteThread}
              threadJumpLabelByKey={state.visibleThreadJumpLabelByKey}
              attachThreadListAutoAnimateRef={state.attachThreadListAutoAnimateRef}
              expandThreadListForProject={state.expandThreadListForProject}
              collapseThreadListForProject={state.collapseThreadListForProject}
              dragInProgressRef={state.dragInProgressRef}
              suppressProjectClickAfterDragRef={state.suppressProjectClickAfterDragRef}
              suppressProjectClickForContextMenuRef={state.suppressProjectClickForContextMenuRef}
              attachProjectListAutoAnimateRef={state.attachProjectListAutoAnimateRef}
              projectDnDSensors={state.projectDnDSensors}
              projectCollisionDetection={state.projectCollisionDetection}
              handleProjectDragStart={state.handleProjectDragStart}
              handleProjectDragEnd={state.handleProjectDragEnd}
              handleProjectDragCancel={state.handleProjectDragCancel}
              projectsLength={state.projectsLength}
              isBootstrappingLocal={state.isBootstrappingLocal}
            />
          </SidebarContent>

          {/* Non-settings only, matching t3code: their update pill lives in
              `SidebarChromeFooter` and is absent from the settings footer. */}
          <SidebarUpdatePill />
        </>
      )}

      {/* Outside the branch on purpose: the account row stays pinned on both
          the main and Settings routes. No separator—the footer's placement and
          spacing already establish the grouping, so a hairline would add an
          unnecessary second boundary in the rail. Same reasoning puts the
          workspace switcher here (CMMD-Center/forge#3572): visible on every
          route the sidebar renders, not only the setup flow. */}
      <ForgeWorkspaceSwitcher />
      <SidebarAccountFooter />
    </>
  );
}
